/*
 * Licensed to The OpenNMS Group, Inc (TOG) under one or more
 * contributor license agreements.  See the LICENSE.md file
 * distributed with this work for additional information
 * regarding copyright ownership.
 *
 * TOG licenses this file to You under the GNU Affero General
 * Public License Version 3 (the "License") or (at your option)
 * any later version.  You may not use this file except in
 * compliance with the License.  You may obtain a copy of the
 * License at:
 *
 *      https://www.gnu.org/licenses/agpl-3.0.txt
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * either express or implied.  See the License for the specific
 * language governing permissions and limitations under the
 * License.
 */
/* Load jQuery first, so Angular finds it */
require('./jquery-js');

/* Angular Core */
const angular = require('angular');
require('angular-animate');
require('angular-cookies');
require('angular-route');
require('angular-resource');
require('angular-sanitize');

/* 3rd-Party Modules */
require('angular-growl-v2');
require('angular-loading-bar');

require('angular-growl-v2/build/angular-growl.css');
require('angular-loading-bar/build/loading-bar.css');

/* Bootstrap UI */
require('vendor/bootstrap-js');
require('angular-bootstrap-checkbox');
require('ui-bootstrap4'); // angular-ui-boostrap for bootstrap 4

console.log('init: angular-js ' + angular.version.full); // eslint-disable-line no-console

module.exports = window['angular'] = angular;